import { BaseInput } from '@/components/BaseInput';
import Logic from './logic';
import { IconLeft } from '../../../../components/Icons';
import { motion } from 'framer-motion';
import { BaseSelectAsync } from '../../../../components/BaseSelectAsync';
import Collapsible from '../../../../components/Collapsible';
import ServicePoint from '../../../../components/ServicePoint';
import { useState } from 'react';
import Attachments from '../../../../components/attachments';
export default function Two() {
  const {
    register,
    control,
    errors,
    onSubmit,
    form,
    setValue,
    goBack,
    step,
    areas,
    dispatch,
    setSearchArea,
    fields,
    append,
    remove,
    servicePoint,
    formData,
    setGovernorate,
    watch
  } = Logic();

  const [areaIdes, setAreaIdes] = useState([]);
  const governorates = [
    { label: 'بغداد', value: 'Baghdad' },
    { label: 'صلاح الدين', value: 'Saladin' },
    { label: 'ذي قار', value: 'DhiQar' }
  ];

  return (
    <motion.form
      initial={{ opacity: 0, y: 10 }}
      exit={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      onSubmit={onSubmit}
      className="flex-1 flex flex-col gap-6 py-14">
      <div className="col-span-3 px-10">
        <BaseSelectAsync
          options={governorates}
          label={'المحافظة'}
          placeholder={'المحافظة'}
          control={control}
          name={'governorate'}
          error={errors['governorate']}
          defaultValue={form.governorate}
          value={watch('governorate') ?? undefined}
          handlerOnChange={(value) => {
            setGovernorate(value.value);
            setValue('area', '');
          }}
        />
      </div>
      <div className="flex-1 flex flex-col gap-4 px-10">
        {fields?.map((area, index) => {
          return (
            <div key={index} className="Card">
              <BaseSelectAsync
                options={areas.filter((item) => {
                  if (areaIdes && areaIdes.length > 0) {
                    return !areaIdes.some((it) => it === item.value);
                  } else {
                    return true;
                  }
                })}
                label="المنطقة"
                name={`areaList[${index}].areaId`}
                placeholder="المنطقة"
                control={control}
                error={errors?.areaList && errors?.areaList[`${index}`]?.areaId}
                // defaultValue={form.area}
                defaultValue={area.areaId}
                isDisabled={step !== 2}
                onInputChange={(v) => {
                  setSearchArea(v);
                }}
                handlerOnChange={(v) => {
                  areaIdes[index] = v.value;
                  setAreaIdes([...areaIdes]);
                  setValue(`areaList[${index}].fdtList`, []);
                }}
              />
              <Collapsible
                disabled={step !== 2}
                title={
                  <div className="flex items-center justify-between">
                    <p>الكابينات</p>
                    <span className="text-xs px-2 text-slate-500">اضغط للتفاصيل</span>
                    <span className="text-red-500 text-xs !h-4 ">
                      {errors?.areaList && errors?.areaList[index]?.fdtList?.message}
                    </span>
                  </div>
                }>
                <div className="mt-4 my-2 border-solid border-t " />
                <ServicePoint
                  disabled={step !== 2}
                  name={`areaList[${index}].fdtList`}
                  data={{ areaId: areaIdes[index] ?? area.areaId?.value }}
                  fdtList={area?.fdtList ?? []}
                  setValue={setValue}
                />
              </Collapsible>
              <Collapsible
                disabled={step !== 2}
                title={
                  <div className="flex items-center justify-between">
                    <p>المرفقات</p>
                    <span className="text-xs px-2 text-slate-500">اضغط للتفاصيل</span>
                  </div>
                }>
                <div className="mt-4 my-2 border-solid border-t " />
                <Attachments
                  name={`areaList[${index}]`}
                  control={control}
                  errors={errors}
                  onSubmit={onSubmit}
                  form={form}
                  register={register}
                  index={index}
                  disabled={step != 2}
                />
              </Collapsible>
              <div className="grid grid-cols-2 gap-6 mb-2">
                <BaseInput
                  name={`areaList[${index}].towersCount`}
                  placeholder="عدد الابراج في المنطقة"
                  register={register}
                  label="عدد الابراج في المنطقة"
                  type="number"
                  error={errors?.areaList && errors?.areaList[index]?.towersCount}
                  defaultValue={area.towersCount}
                  disabled={step !== 2}
                />
                <BaseInput
                  name={`areaList[${index}].subsCount`}
                  placeholder="عدد المشتركين في المنطقة"
                  register={register}
                  label="عدد المشتركين في المنطقة"
                  type="number"
                  error={errors?.areaList && errors?.areaList[index]?.subsCount}
                  defaultValue={area.subsCount}
                  disabled={step !== 2}
                />
              </div>
              {fields.length - 1 > 0 && step == 2 && (
                <div className="w-full flex flex-row-reverse mt-2">
                  <button
                    type="button"
                    className="border py-1 px-2 rounded-md bg-red-500/10 text-red-500 hover:border-red-500  "
                    onClick={() => {
                      remove(index);
                    }}>
                    حذف
                  </button>
                </div>
              )}
            </div>
          );
        })}
        {step == 2 && (
          <div className="w-full flex flex-row-reverse ">
            <button
              type="button"
              className="border py-1 px-2 rounded-md bg-blue-500/10 text-blue-500 hover:border-blue-500  "
              onClick={() => {
                append({ towersCount: 0, subsCount: 0, fdtList: [] });
              }}>
              اضافة منطقة
            </button>
          </div>
        )}
      </div>
      {step === 2 && (
        <div className="flex justify-between col-span-2 mt-5 bg-white h-20 items-center border-t border-gray-200 px-5 ">
          <button
            onClick={goBack}
            className="flex bg-gray-100 border border-gray-200 py-2 rounded-3xl text-slate-500 fill-slate-400 disabled:opacity-60"
            type="button">
            <span className="px-2 border-r border-slate-300 rotate-180">
              <IconLeft />
            </span>
            <span className="px-6">الـسـابـق</span>
          </button>
          <button
            className="flex bg-gray-100 py-2  border border-gray-200 rounded-3xl text-slate-500 fill-slate-400 hover:border-slate-300"
            type="submit">
            <span className="px-6">الـتـالـي</span>
            <span className="px-2 border-r border-slate-300">
              <IconLeft />
            </span>
          </button>
        </div>
      )}
    </motion.form>
  );
}
